import React from "react";
import styled from "styled-components";
import { Typography } from "ui-kit/Typography";

interface LogoProps {
  fw?: number;
  fs?: number;
  open?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ open }) => {
  return (
    <Container open={open}>
      <div style={{ width: '100%', display: 'flex', justifyContent: open ? 'flex-start' :'center', }}>
        <StyledLogo open={open}>
          <span>/</span> {open && "music"}
        </StyledLogo>
      </div>
    </Container>
  );
};

const Container = styled.div<{ open?: boolean }>`
  width:100%;
  display: flex;
`;

const StyledLogo = styled(Typography) <LogoProps>`

  font-family: 'Outfit';
  font-weight: ${props => props.fw || 700};
  font-size: ${props => `${props.fs || 26}px`};
  cursor: pointer;
  display: flex;
  align-items: center;
  
  gap:2px;

  span {
    color: #6777FF;
  }
`;
